import { APIResource, APIError, APIResponse } from "../utils/APIResource";

export default class otpService {

  static sendOtp(data, txId,regenerateOtp) {
    return APIResource.post(
      `/v1/otp/notify`,
      {
        notificationMethod: data,
        regenerateOtp: regenerateOtp
      },
      {
        headers: {
          "x-auth-type": "CIAM",
          "x-auth-tx-id": txId
        }
      }
    )
      .then(resp => {
        return Promise.resolve(new APIResponse(resp));
      })
      .catch(error => {
        console.error("Error sending OTP:", error);
        return Promise.reject(new APIError(error));
      });
  }
}
